<template>
  <div id="app">
    <DisabledPage v-if="disabled" />
    <router-view v-else />
  </div>
</template>

<script>
import DisabledPage from "./DisabledPage";
import api from "./http/api";
export default {
  components: {
    DisabledPage,
  },
  data() {
    return {
      disabled: false,
    };
  },
  async created() {
    try {
      await api.System.CheckApp();
    } catch (e) {
      this.disabled = true;
      return;
    }

    if (window.location.pathname !== "/login") {
      await this.$store.dispatch("autoLogin");
      this.$store.dispatch("setCount");
      console.log("create");
    }
  },
};
</script>
<style lang="less" src="./assets/common.less">
</style>



// WEBPACK FOOTER //
// src/App.vue